import React, { useEffect, useState } from 'react'
import { Col, Container, Nav, Row } from 'react-bootstrap'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomTable from '../Components/CustomTable/CustomTable'
import Breakfast from '../assets/Breakfast item.png'
import Breakfast1 from '../assets/breakfast4.png'
import lunch from '../assets/lunch.png'
import dinner from '../assets/dinner.png'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTrainerMainMeals } from '../hooks/MainMeals'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Meals() {
  const dispatch = useDispatch()
  const { list: weekList } = useSelector((state) => state.week);
  const { list: MainMealsList, Pagination: MainMealsPagination } = useSelector((state) => state.mainMeals);
  const subcategories = MainMealsList.filter((meal) => meal.parent_id !== null)
  const { list: profile } = useSelector((state) => state.Profile)
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [viewMode, setViewMode] = useState("day");

  useEffect(() => {
    dispatch(fetchTrainerMainMeals(profile?.restaurant?.id))
  }, [])
  const dayKey = selectedDate
    .toLocaleDateString('en-US', { weekday: 'short' })
    .toLowerCase();
  const today = new Date();
  const todayStr = new Date().toISOString()?.split("T")[0];

  const result = weekList.find(item => {
    const start = item.start_date?.split("T")[0];
    const end = item.end_date?.split("T")[0];

    return todayStr >= start && todayStr <= end;
  });
  console.log(result);


  const header = [
    "صورة الصنف",
    "اسم الصنف",
    "التصنيف",
    "تاريخ الاضافة",
    "الحالة",

    "",


  ]
  const studentsData = [
    { id: 1, name: 'بيض', category: 'فطار', date: "13/4/2025 22:00", image: Breakfast, active: "true" },
    { id: 2, name: 'سمك', category: 'غذاء', date: "13/4/2025 22:00", image: Breakfast, active: "false" },
    { id: 3, name: 'جبن', category: 'عشاء', date: "13/4/2025 22:00", image: Breakfast, active: "true" },
  ]
  const fiteration = [
    { id: 0, title: "الوجبات", options: [{ id: "01", title: "الافطار" }, { id: "02", title: "الغداء" }, { id: "03", title: "العشاء" }] },
  ]
  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };
  const formattedSelectedDate = selectedDate
    ?.toISOString()
    ?.split("T")[0];

  const filteredMeals = subcategories.filter((meal) => {
    return meal.date?.split("T")[0] === formattedSelectedDate;
  });
  return (
    <>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={`قائمة الطعام ${viewMode == "day"
            ? formatDate(selectedDate)
            : formatDate(result?.start_date)
            }
${viewMode != "day" ? " _______ " : ""}
${viewMode != "day" ? formatDate(result?.end_date) : ""}`}
          subtitle={""}
          downloadData={false}
          addData={false}
          status={"meal"}


        />
        <Row>
          <Col md={6}>
            <Nav variant="pills" className="mb-3">
              <Nav.Item>
                <Nav.Link
                  active={viewMode === "day"}
                  onClick={() => setViewMode("day")}
                >
                  يومي
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  active={viewMode === "week"}
                  onClick={() => setViewMode("week")}
                >
                  أسبوعي
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          {viewMode === "day" &&
            <Col md={3}>
              <DatePicker
                className="form-control"

                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
              />

            </Col>
          }
        </Row>
        {/* <Row>
                  <Col md={3}>
          <select
            className="form-control"
            value={selectedRestaurant}
            onChange={(e) => setSelectedRestaurant(e.target.value)}
          >
            <option value="all">كل المطاعم</option>
            {resturants.map((r) => (
              <option key={r.id} value={r.id}>
                {r.name}
              </option>
            ))}
          </select>
        </Col>
      
                  <Col md={6}>
                    <Nav variant="pills" className="mb-3">
                      <Nav.Item>
                        <Nav.Link
                          active={viewMode === "day"}
                          onClick={() => setViewMode("day")}
                        >
                          يومي
                        </Nav.Link>
                      </Nav.Item>
        
                      <Nav.Item>
                        <Nav.Link
                          active={viewMode === "week"}
                          onClick={() => setViewMode("week")}
                        >
                          أسبوعي
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                </Row> */}
        {viewMode !== "day" ? <Row className='mt-5 mx-4'>
          {subcategories.filter((meal) => meal.parent_id == 10).length > 0 &&
            <Col md={12}>
              <div className='body_container'>
                <strong className='mb-3'>الافطار</strong>
                {/* <div className='d-flex align-items-center'> */}
                <Container fluid>
                  <Row>
                    {subcategories.filter((meal) => meal.parent_id == 10).map((item) => {
                      return (
                        <Col md={3} className='mb-3'>
                          <div>
                            <img src={item.image ? item.image : Breakfast1} alt="meal" className='w-100' />
                            <h5>{item.name}</h5>
                            <p>  <small className='text-muted '>{item?.date}</small></p>
                            <small className='text-muted '>{item?.day}</small>

                            {item?.description !== null &&
                              <p className='mt-4'>{item?.description}</p>
                            }
                          </div>
                        </Col>
                      )
                    })}
                  </Row>
                </Container>
              </div>
            </Col>
          }
          {subcategories.filter((meal) => meal.parent_id == 11).length > 0 &&

            <Col md={12}>
              <div className='body_container'>
                <strong className='mb-3'>الغداء</strong>
                <Container fluid>
                  <Row>
                    {subcategories.filter((meal) => meal.parent_id == 11).map((item) => {
                      console.log(item);
                      return (
                        <Col md={3} className='mb-3'>
                          <div className='mx-2'>
                            <img src={item.image ? item.image : lunch} alt="meal" className='w-100' />
                            <h5>{item.name}</h5>
                            <p>  <small className='text-muted '>{item?.date}</small></p>
                            <small className='text-muted '>{item?.day}</small>

                            {item?.description !== null &&
                              <p className='mt-4'>{item?.description}</p>
                            }
                          </div>
                        </Col>
                      )
                    }
                    )}
                  </Row>
                </Container>
              </div>
            </Col>
          }
          {subcategories.filter((meal) => meal.parent_id == 12).length > 0 &&

            <Col md={12}>
              <div className='body_container'>
                <strong className='mb-3'>العشاء</strong>
    <Container fluid>
                  <Row>
                                      {subcategories.filter((meal) => meal.parent_id == 12).map((item) => {
                    return (
            <Col md={3} className='mb-3'>
                        <div>
                        <img src={item.image ? item.image : dinner} alt="meal" className='w-100' />
                        <h5>{item.name}</h5>
                        <p>  <small className='text-muted '>{item?.date}</small></p>
                        <small className='text-muted '>{item?.day}</small>

                        {item?.description !== null &&
                          <p className='mt-4'>{item?.description}</p>
                        }
                      </div>
            </Col>
                      )
                  }
                  )}
</Row>
</Container>
              </div>
            </Col>
          }
        </Row>
          :
          <>
            {filteredMeals.length > 0 ?
              <Row className='mt-5 mx-4'>
                {filteredMeals
                  .filter((meal) => meal.parent_id == 10).length > 0 &&
                  <Col md={4}>
                    <div className='body_container'>
                      <strong className='mb-3'>الافطار</strong>
                      <div className='d-flex align-items-center '>
                        {filteredMeals
                          .filter((meal) => meal.parent_id == 10)
                          .map((item) => {
                            return (
                              <div key={item.id}>
                                <img src={item.image ? item.image : Breakfast1} alt="meal" className='w-100' />
                                <h5>{item.name}</h5>
                                <small className='text-muted '>{item?.day}</small>
                                {item?.description !== null &&
                                  <p className='mt-4'>{item?.description}</p>
                                }

                              </div>
                            )
                          })}
                      </div>
                    </div>

                  </Col>
                }

                {filteredMeals
                  .filter((meal) => meal.parent_id == 11).length > 0 &&
                  <Col md={4}>
                    <div className='body_container'>
                      <strong className='mb-3'>الغداء</strong>
                      <div className='d-flex align-items-center mt-4'>
                        {filteredMeals
                          .filter((meal) => meal.parent_id == 11)
                          .map((item) => {
                            return (
                              <div key={item.id}>
                                <img src={item.image ? item.image : lunch} alt="meal" className='w-100' />
                                <h5>{item.name}</h5>
                                <small className='text-muted '>{item?.day}</small>
                                {item?.description !== null &&
                                  <p className='mt-4'>{item?.description}</p>
                                }

                              </div>
                            )
                          })}
                      </div>
                    </div>

                  </Col>
                }

                {filteredMeals
                  .filter((meal) => meal.parent_id == 12).length > 0 &&
                  <Col md={4}>
                    <div className='body_container'>
                      <strong className='mb-3'>العشاء</strong>
                      <div className='d-flex align-items-center mt-4'>
                        {filteredMeals
                          .filter((meal) => meal.parent_id == 12)
                          .map((item) => {
                            return (
                              <div key={item.id}>
                                <img src={item.image ? item.image : dinner} alt="meal" className='w-100' />
                                <h5>{item.name}</h5>
                                <small className='text-muted '>{item?.day}</small>
                                {item?.description !== null &&
                                  <p className='mt-4'>{item?.description}</p>
                                }

                              </div>
                            )
                          })}
                      </div>
                    </div>

                  </Col>
                }
              </Row>
              :
              <div className='d-flex justify-content-center  align-items-center mt-5 fw-bold'>لا توجد بيانات</div>

            }
          </>
        }

        {/* <div className='meals_container'>
          {subcategories.filter((meal) => meal.parent_id == 10).length>0&&
          <div className='body_container' style={{ width: "30%" }}>
            <strong className='mb-3'>الافطار</strong>
            <div className='d-flex align-items-center mt-4'>
              {subcategories.filter((meal) => meal.parent_id == 10).map((item) => {

                return (
                  <div>
                    <img src={item.image} alt="meal" className='w-100' />
                    <h5>{item.name}</h5>
                    {item?.description!=null&&
        <p className='mt-4'>{item?.description}</p>
}
                  </div>
                )
              })}
            </div>

          </div>
}
          {subcategories.filter((meal) => meal.parent_id == 11).length > 0 &&
            <div className='body_container' style={{ width: "30%" }}>
              <strong className='mb-3'>الغداء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 11).map((item) => {
                  console.log(item);

                  return (
                    <div className='mx-2'>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      {item?.description!=null&&
        <p className='mt-4'>{item?.description}</p>
}
                    </div>
                  )
                })}
              </div>
            </div>

          }
          {subcategories.filter((meal) => meal.parent_id == 12).length > 0 &&
            <div className='body_container' style={{ width: "30%" }}>
              <strong className='mb-3'>العشاء</strong>
              <div>
                {subcategories.filter((meal) => meal.parent_id == 12).map((item) => {
                  return (
                    <div>
                      <img src={item.image} alt="meal" className='w-100' />
                      <h5>{item.name}</h5>
                      {item?.description!=null&&
        <p className='mt-4'>{item?.description}</p>
}
                    </div>)
                })}
              </div>
            </div>
          }

        </div> */}
        {/* <Row className='mt-5 mx-4'>
<Col md={4}>
<div className='body_container'>
<strong className='mb-3'>الافطار</strong>

</div>
</Col>
<Col md={4}>fdsk</Col>
<Col md={4}>fdsk</Col>
</Row> */}
      </Container>
    </>
    // <div>
    //   <AuthNavbar />
    //   <Container>
    // <CustomHeader
    //   title={"قائمة الطعام"}
    //   subtitle={""}
    //   downloadData={false}
    //   addData={true}
    //   status={"meal"}


    // />
    //     <CustomTable
    //       data={studentsData}
    //       fiteration={fiteration}
    //       currentData={25}
    //       allData={' 1,248  مستفيد'}
    //       header={header}
    //       actions={["تعديل", "حذف"]}
    //       status={"meal"}

    //     />
    //     <CustomPagination
    //       currentData={1}
    //       allData={25}
    //       datainPage={5}

    //     />
    //   </Container>
    // </div>
  )
}

export default Meals